export const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/919281410305?text=Hi%20I%20am%20interested%20in%20your%20web%20design%20services"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg"
      style={{ backgroundColor: "#25D366" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="26"
        height="26"
        fill="white"
      >
        <path d="M16 .396C7.164.396 0 7.56 0 16.396c0 2.889.757 5.6 2.074 7.945L.396 32l7.84-1.63a15.89 15.89 0 007.764 1.98h.006c8.836 0 16-7.164 16-16S24.842.396 16 .396zm0 29.238c-2.56 0-5.06-.68-7.236-1.968l-.52-.308-4.65.968.99-4.533-.338-.533A13.25 13.25 0 012.75 16.4c0-7.33 5.96-13.29 13.29-13.29 3.55 0 6.88 1.38 9.39 3.89a13.2 13.2 0 013.9 9.39c0 7.33-5.96 13.29-13.29 13.29zm7.28-9.98c-.4-.2-2.37-1.17-2.74-1.3-.37-.14-.64-.2-.9.2-.27.4-1.04 1.3-1.28 1.56-.23.27-.47.3-.87.1-.4-.2-1.68-.62-3.2-1.97-1.18-1.05-1.97-2.34-2.2-2.73-.23-.4-.02-.62.17-.82.18-.18.4-.47.6-.7.2-.23.27-.4.4-.67.14-.27.07-.5-.03-.7-.1-.2-.9-2.17-1.23-2.97-.32-.77-.65-.67-.9-.68l-.77-.01c-.27 0-.7.1-1.06.5-.37.4-1.4 1.37-1.4 3.33 0 1.97 1.43 3.87 1.63 4.13.2.27 2.8 4.27 6.78 5.99.95.41 1.69.65 2.27.83.95.3 1.81.26 2.49.16.76-.11 2.37-.97 2.7-1.9.33-.94.33-1.74.23-1.9-.1-.17-.37-.27-.77-.47z"/>
      </svg>
    </a>
  );
};
